import { Flex, Loading } from 'ui'
import { useCompanyMembersContext } from '../context/CompanyMembersProvider'
import { CompanyMembersTable } from './CompanyMembersTable'
import { Header } from './Header'
import { EmptyState } from './EmptyState'
import { EditMember } from './EditMember/EditMember'

export const CompanyMembersMain = () => {
  const {
    state: { membersPage, isLoading, isFetchingNextPage, selectedMemberId },
    actions: { setSelectedMemberId },
  } = useCompanyMembersContext()

  const showLoading =
    (isLoading || isFetchingNextPage) && membersPage.length === 0
  const showEmptyState = membersPage.length === 0 && !showLoading
  const showEditMemberModal = !!selectedMemberId

  return (
    <Flex flexDirection="column" gap={3}>
      <Header />
      {!!showLoading && <Loading />}
      {!!membersPage.length && <CompanyMembersTable />}
      {!!showEmptyState && <EmptyState />}
      {!!showEditMemberModal && (
        <EditMember
          memberId={selectedMemberId}
          onClose={() => setSelectedMemberId(undefined)}
        />
      )}
    </Flex>
  )
}
